import React from "react";
import { useLocation } from "react-router-dom";
import Pagination from "components/ViewPagesPagination";
import PostageWallet from "components/Shipements/PostageWallet";

function PostageWallets() {
  const location = useLocation();
  
  // Determine the base route based on current location
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  
  // return <PostageWallet.tsxs baseRoute={baseRoute} />;
  return <PostageWallet   />;
}
export default PostageWallets;
